export default __webpack_public_path__ + "static/media/info-icon.1c7515d9.svg";